var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":(_vm.hidelabel) ? '' : 'Emitente:',"hidelabel":_vm.hidelabel,"placeholder":"Busca Emitente por Nome, CPF/CNPJ, Código ou Data de nascimento","funcaoBuscar":"getEmitentes","incluir":_vm.incluir,"alterar":_vm.alterar,"tipo":"emitente"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }